import type { Program } from 'models';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, message } from 'ui';
import { useCreateAbuseReport } from '../../../report';

export const useConfirmReportProgram = () => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();

  const { mutate: createAbuseReport } = useCreateAbuseReport();

  const confirmReportProgram = useCallback(
    (program: Program) => {
      modal.confirm({
        onOk() {
          createAbuseReport(
            { programId: program.id },
            {
              onSuccess() {
                message.success('Successfully reported.');
              },
            },
          );
        },
        title: t('Are you sure you want to report this program?'),
      });
    },
    [createAbuseReport, modal, t],
  );

  return useMemo(() => ({ confirmReportProgram, contextHolder }), [confirmReportProgram, contextHolder]);
};
